import React from 'react';
import ResourceForm from '../../components/ResourceForm';
import StepShell from '../shared/StepShell';
import { siteField } from '../shared/options';

export default function SiteStep({ grave, state, sites, onNext, onCancel, loading }) {
  return (
    <StepShell>
      <h3>Site</h3>
      <ResourceForm
        resource={{ id: grave?.id, type: 'Grave' }}
        fields={[siteField(sites, state.siteId)]}
        onSubmit={onNext}
        onCancel={onCancel}
        loading={loading}
        submitLabel="Save & Continue"
      />
    </StepShell>
  );
}
